/**
 * @fileoverview Custom element for handling details disclosure functionality
 */
class DetailsDisclosure extends HTMLElement {
  /**
   * Creates a new DetailsDisclosure instance
   * Sets up event listeners for keyboard and focus events
   */
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    document.addEventListener('click', this.onFocusOut.bind(this));
  }

  /**
   * Handles escape key press to close disclosure
   * @param {KeyboardEvent} event - The keyboard event
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  /**
   * Handles focus out event to close disclosure
   * @param {Event} e - The focus event
   */
  onFocusOut(e) {
    const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

    if (!withBoundaries) {
      this.mainDetailsToggle.removeAttribute('open');
    }
  }

  /**
   * Closes the disclosure
   */
  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
